module.exports = __webpack_public_path__ + "static/img/LOGO_Life.fba5b292.png";